import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { SIGNUP_TAB_COMPLETED } from '../../util/types';
import { getBusinessListingParams } from '../../util/data';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  const { className, rootClassName, currentPage, showManageListingsLink, params, currentUser } = props;
  const intl = useIntl();

  const classes = classNames(rootClassName || css.root, className);
  const {
    publicData,
    protectedData
  } = (currentUser && currentUser.id && currentUser.attributes.profile) || {};
  const { isAdmin } = publicData || {};
  const {
    signUpCompleted,
    businessListingId = false,
    // businessListingPublished = false
  } = protectedData || {};
  const inboxPage = ['DashboardBasePage', 'EventDashboardPage', 'ProviderDashBoardPage'].includes(currentPage);

  const manageListingsTabMaybe = showManageListingsLink
    ? [
      {
        text: <FormattedMessage id="UserNav.yourListings" />,
        selected: currentPage === 'ManageListingsPage',
        linkProps: {
          name: 'ManageListingsPage',
        },
      },
    ]
    : [];

  const tabs = [
    // ...manageListingsTabMaybe,
    // {
    //   text: <FormattedMessage id="UserNav.profileSettings" />,
    //   selected: currentPage === 'ProfileSettingsPage',
    //   disabled: false,
    //   linkProps: {
    //     name: 'ProfileSettingsPage',
    //   },
    // },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  // if (signUpCompleted == SIGNUP_TAB_COMPLETED) {
  //   tabs.push({
  //     text: <FormattedMessage id="UserNav.editApplication" />,
  //     selected: currentPage === 'SignUpStepsPage',
  //     linkProps: {
  //       name: 'SignUpStepsPage',
  //       params: { tab: "detail" }
  //     },
  //   });
  // }

  // if (businessListingId) {
  //   tabs.push({
  //     text: <FormattedMessage id="UserNav.editBusiness" />,
  //     selected: currentPage === 'EditListingPage',
  //     linkProps: {
  //       name: 'EditListingPage',
  //       params: getBusinessListingParams(currentUser)
  //     },
  //   });
  // }

  const dashboardTabs = [{
    text: <FormattedMessage id="UserNav.bidderDashboardPage" />,
    selected: ("owner" == params.tab),
    disabled: false,
    linkProps: {
      name: 'EventDashboardPage',
      params: {
        tab: 'owner'
      }
    },
  },
  {
    text: <FormattedMessage id="UserNav.ownerDashBoardPage" />,
    selected: "ProviderDashBoardPage" == currentPage,
    disabled: false,
    linkProps: {
      name: 'ProviderDashBoardPage',
    },
  }];

  if (isAdmin) {
    dashboardTabs.push({
      text: <FormattedMessage id="UserNav.adminDashboardPage" />,
      selected: ("admin" == params.tab),
      disabled: false,
      linkProps: {
        name: 'AdminDashboardBasePage',
      },
    });
  }

  return (
    <LinkTabNavHorizontal
      className={classes}
      tabRootClassName={css.tab}
      tabs={inboxPage ? dashboardTabs : tabs}
      skin="dark"
      ariaLabel={intl.formatMessage({ id: 'UserNav.screenreader.userNav' })}
    />
  );
};

export default UserNav;
